import React from 'react';
import SparklesIcon from './icons/SparklesIcon';
import InfoIcon from './icons/InfoIcon';
import CheckCircleIcon from './icons/CheckCircleIcon';

const TreatmentSummaryDisplay: React.FC<{ plan: any; genText: string | null }> = ({ plan, genText }) => {
    if (!plan && !genText) {
        return <p className="text-sm text-zinc-400">No AI-generated plan or notes are available for this simulation.</p>;
    }

    const isNewPlanFormat = plan?.designRationale && plan?.summary?.holisticImpression;

    let summaryItems: { label: string; value: string; icon: React.ReactNode; justification?: string }[] = [];

    if (isNewPlanFormat) {
        summaryItems = [
            {
                label: 'Design Theme',
                value: plan.designRationale.chosenSmilePreset,
                icon: <SparklesIcon className="w-4 h-4 text-teal-300" />,
                justification: plan.designRationale.justification
            },
            {
                label: 'Holistic Impression',
                value: plan.summary.holisticImpression,
                icon: <InfoIcon className="w-4 h-4 text-teal-300" />
            },
            {
                label: 'Implied Treatment Path',
                value: plan.summary.treatmentModality,
                icon: <CheckCircleIcon className="w-4 h-4 text-teal-300" />
            },
        ];
    } else if (plan?.summary) { // Fallback to old format
        summaryItems = [
            { label: 'Design Theme', value: plan.SmileDesignPreset || "AI Generated Plan", icon: <SparklesIcon className="w-4 h-4 text-teal-300" /> },
            { label: 'Overall Impression', value: plan.summary.overallImpression, icon: <InfoIcon className="w-4 h-4 text-teal-300" /> },
            { label: 'Recommended Treatment', value: plan.summary.treatmentRecommendation, icon: <CheckCircleIcon className="w-4 h-4 text-teal-300" /> },
        ];
    }

    return (
        <div className="space-y-4 text-sm">
            {summaryItems.length > 0 && (
                <div className="space-y-4">
                    {summaryItems.map(item => (
                        <div key={item.label} className="flex items-start gap-3">
                            <div className="flex-shrink-0 mt-0.5 w-6 h-6 rounded-lg bg-teal-900/40 flex items-center justify-center">{item.icon}</div>
                            <div>
                                <p className="font-semibold text-zinc-200">{item.label}</p>
                                <p className="mt-0.5 text-zinc-400">{item.value}</p>
                                {item.justification && (
                                    <blockquote className="mt-2 text-xs text-zinc-500 italic border-l-2 border-teal-800/70 pl-3">
                                        {item.justification}
                                    </blockquote>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}

        </div>
    );
};

export default TreatmentSummaryDisplay;
